const env = process.env.REACT_APP_ENV;

let logoImages;

switch (env) {
  case 'atela':
    logoImages = {
      logo: require('./img/storyportal-logo.png'),
      logoinner: require('./img/storyportal-logo.png'),
      whiteLogo: require('./img/storyportal-white-logo.png'),
      embeddLogo: require('./img/storyportal-embeddLogo.png'),
      vpSwirl: require('./img/storyportal-swirl.png'),
    };
    break;

  case 'storyportal':
    logoImages = {
      logo: require('./img/storyportal-logo.png'),
      logoinner: require('./img/storyportal-logo.png'),
      whiteLogo: require('./img/storyportal-white-logo.png'),
      embeddLogo: require('./img/storyportal-embeddLogo.png'),
      vpSwirl: require('./img/storyportal-swirl.png'),
    };
    break;

  default:
    logoImages = {
      logo: require('./img/videopeel-logo.png'),
      logoinner: require('./img/videopeel-logo.png'),
      whiteLogo: require('./img/videoPeel-white-logo.png'),
      embeddLogo: require('./img/embeddLogo.png'),
      vpSwirl: require('./img/vp-swirl.png'),
    };
    break;
}

const images = {
  ...logoImages,
  user: require('./img/User.png'),
  splashuser: require('./img/user1.png'),
  appsumo: require('./img/appsumo.png'),
};

export default images;



// WEBPACK FOOTER //
// ./src/style/images.js